import type { CSSProperties } from 'react';
import styles from './Divider.module.css';

interface DividerProps {
  vertical?: boolean;
  padding?: string;
}

export function Divider({ vertical, padding }: DividerProps) {
  let style: CSSProperties | undefined;
  if (padding) {
    style = vertical ? { paddingInline: padding } : { paddingBlock: padding };
  }

  return (
    <hr className={vertical ? styles.vertical : styles.divider} style={style} />
  );
}
